var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteLeft(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "9px",
    viewBox: "0 0 11 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "quoteLeft") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-7",
    transform: "translate(-61.000000, -2158.000000)",
    fill: "#7BCB45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3376594,2159.14629 C64.2468975,2160.21616 63.60006,2161.29875 63.3971276,2162.39409 L65.2615601,2162.39409 L64.9191133,2166.36788 L61,2166.36788 L61.2282979,2163.57859 C61.3043975,2162.50872 61.5580593,2161.52165 61.9892907,2160.61735 C62.4205222,2159.71306 63.0927258,2158.84061 64.0059219,2158 L65.3376594,2159.14629 Z M71.7299995,2159.14629 C70.6392376,2160.21616 69.9924002,2161.29875 69.7894677,2162.39409 L71.6539003,2162.39409 L71.3114535,2166.36788 L67.3923402,2166.36788 L67.620638,2163.57859 C67.6967377,2162.50872 67.9503994,2161.52165 68.3816309,2160.61735 C68.8128623,2159.71306 69.485066,2158.84061 70.398262,2158 L71.7299995,2159.14629 Z",
    id: "quoteLeft"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteLeft);
export default __webpack_public_path__ + "static/media/quoteLeft.0cf14e03142f149b5febf74dadaa2042.svg";
export { ForwardRef as ReactComponent };